import React, { Component } from 'react';
//import './Style.css';
import '../../custom.css'

export function Alert(props) {

    const alertCloseClick = event => {
        if (props.callBack) {
            props.callBack(event)
        }
    }

    return (
        <div className={`alert ${props.Type} alert-dismissible fade show`} role="alert">
            <strong>{props.Title}</strong> {props.Body}
            <button type="button" class="close" onClick={alertCloseClick} aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    );
}
